/** An alias: what the Operator's URLs name a dataspace or a process by instead of its id (`AliasField`). */
export default {
	alias: {
		label: "Alias",
		hint: "Optional. A short name its URL uses instead of the ID.",
		opens: "Its URL: {path}",
		problem: {
			form: "Letters a to z, digits and hyphens only",
			length: "At most {max} characters",
			id: "An alias cannot look like an ID",
			reserved: "“{alias}” is used by the app and cannot be an alias",
		},
		taken: "This alias is already in use",
	},
};
